<template>
  <vinnuskoli-page>
    <b-row class="mb-3">
      <b-col>
        <div class="page-title mb-0">Verkefnategundir</div>
      </b-col>
      <b-col class="d-flex justify-content-end" v-if="loggedInUserHasAnyPermission('write_attendanceproject')">
        <b-btn variant="primary" @click.prevent="projectCreateModal" class="pull-right">
          <i class="fa fa-fw fa-plus-circle"></i>
          Bæta við
        </b-btn>
      </b-col>
    </b-row>
    <b-card no-body border-variant="light" class="mb-2">
      <table class="table mb-0">
        <thead>
          <tr class="bg-gray-200 small">
            <th>Heiti</th>
            <th></th>
          </tr>
        </thead>
        <tbody v-if="loading">
          <td colspan="100"><loading /></td>
        </tbody>
        <tbody v-if="projectList.length == 0 && !loading">
          <td colspan="100"><i>Engar leitarniðurstöður fundust.</i></td>
        </tbody>
        <tbody v-if="!loading && projectList.length > 0">
          <tr v-for="project in projectList" :key="project.id">
            <td>{{ project.name }}</td>
            <td class="text-right">
              <b-btn
                :size="'sm'"
                variant="primary"
                @click.prevent="projectEditModal(project.id)"
                v-if="loggedInUserHasAnyPermission('write_attendanceproject')"
              >
                <i class="fa fa-fw fa-pencil"></i>
              </b-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </b-card>
    <project-create-modal ref="projectCreateModal" @successful="loadList"></project-create-modal>
    <project-create-modal ref="projectEditModal" @successful="loadList"></project-create-modal>
  </vinnuskoli-page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import attendance from '@/api/attendance';
import projectCreateModal from '@/components/attendanceProject/ProjectCreateModal.vue';

export default {
  name: 'attendanceProject',
  components: {
    projectCreateModal,
  },
  computed: {
    ...mapGetters(['loggedInUserHasAnyPermission', 'loggedInUserOptions']),
  },
  data() {
    return {
      projectList: [],
      loading: false,
    };
  },
  methods: {
    async loadList() {
      this.loading = true;
      this.projectList = [];
      try {
        const response = await attendance.attendanceProjectList();
        this.projectList = response.data;
      } catch (e) {
        this.$log.error(e);
        this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
      } finally {
        this.loading = false;
      }
    },
    /*
     * Modal gluggar
     */
    projectCreateModal() {
      this.$refs.projectCreateModal.show();
    },
    projectEditModal(id) {
      this.$refs.projectEditModal.show(id);
    },
    ...mapActions({
      displayError: 'displayError',
      displaySuccess: 'displaySuccess',
    }),
  },
  created() {
    this.loadList();
  },
};
</script>

<style></style>
